import { useAppSelector } from "@js/hooks";

import { getSelectedBidIds } from "../../components/bulk-select-actions/bid-bulk-selection-slice";

export const useSelectedBidsIds = () => {
  const selectedBidsIds = useAppSelector(getSelectedBidIds);
  return { selectedBidsIds };
};
